/** @jsxImportSource @emotion/react */
import { Button, Icon } from "@coreai/component-library";
import { css, useTheme } from "@emotion/react";
import React, { useEffect, useState } from "react";
import { useLanguage } from "../../../../LanguageContext";

interface EditDescriptionModalProps {
  setIsEditDescOpen: (isOpen: boolean) => void;
  setCharacterCount: (val: number) => void;
  value: string;
  characterCount: number;
  setReview: (val: string) => void;
  CHARACTER_LIMIT: number;
}
export default function EditDescriptionModal(props: Readonly<EditDescriptionModalProps>) {

  const { setIsEditDescOpen, value, characterCount, CHARACTER_LIMIT, setCharacterCount, setReview } = props;
  const theme = useTheme();
  const { t } = useLanguage();

  const [tempValue, setTempValue] = useState(value);

  useEffect(() => {
    setTempValue(value);
    setCharacterCount(value.length);
  }, [value, setCharacterCount]);

  const handleSave = () => {
    setReview(tempValue);
    setIsEditDescOpen(false);
  };

  const handleCancel = () => {
    setTempValue(value);
    setCharacterCount(value.length);
    setIsEditDescOpen(false);
  };

  const handleReviewChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const _val = event.target.value.replace(/^\s+/, "").replace(/\s+$/, " ");
      setTempValue(_val);
      setCharacterCount(_val.length);
      if (_val.length >= 1){
        window.isAnalysisDescFilled = true;
      } else{
        window.isAnalysisDescFilled = false;
      }
  };

  const modalOverlayStyle = css`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  `;

  const modalContentStyle = css`
    position: relative;
    width: 80vw;
    height: 80vh;
    max-width: 60%;
    max-height: 80%;
    background-color: #fff;
    border-radius: 24px;
    overflow: hidden;
  `;

  const modalContentHeaderStyle = css `
    padding: 24px;
    border-bottom: 1px solid #EAEEF0;
    position: relative;
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    text-align: center;
  `;

  const closeBtnStyle = css`
    position: absolute;
    right: 24px;
    top: 26px;
    cursor: pointer;
  `;

  const modalContentBodyStyle = css`
    padding: 18px 24px;
    height: calc(100% - 144px);
  `;

  const modalContentFooterStyle = css`
    position: absolute;
    bottom: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    padding: 18px 24px;
    background-color: #fff;
    border-top: 1px solid #EAEEF0;
    >button{
      width: 180px;
    }
  `;

  const bodyHeaderStyle = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
  `;
  
  const titleWrapper = css`
    margin-top: 0px;
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
  `;

  const counterStyles = css`
    display: flex;
    font-size: ${theme.typography.body.fontSize};
    color: ${characterCount >= CHARACTER_LIMIT
        ? theme.colors.red
        : theme.colors.textMedium};
    margin-top: 0px;
  `;

  const textareaStyles = css`
      color: ${theme.colors.textMedium};
      height: 90%;
      width: 100%;
      font-size: 16px;
      padding: 10px;
      box-sizing: border-box;
      resize: vertical;
      overflow: auto;
      border-radius: ${theme.radius.xs};
      border: 1px solid hsl(198, 11%, 71%);
      resize: none;
      scrollbar-color: hsl(198, 11%, 60%) transparent;
  
      &:hover {
        background-color: var(--bg-secondary);
        border-color: var(--border-secondary);
      }
      &:focus {
        background-color: var(--bg-secondary);
        border-color: var(--border-brand-primary);
        outline: 2px solid transparent;
        outline-offset: 2px;
      }
    `;
  

  return (
    <div css={modalOverlayStyle}>
      <div css={modalContentStyle}>
        <div css={modalContentHeaderStyle}>
          {t("form_inputFile_ModalDescTitle")}
          <Icon name="x-close" size="xs" css={closeBtnStyle} onClick={() => handleCancel()}/>
        </div>
        <div css={modalContentBodyStyle}>
            <div css={bodyHeaderStyle}>
                <p css={titleWrapper}>{t("form_inputFile_ModalTitleExplain")}</p>
                <p css={counterStyles}>
                    {characterCount}/{CHARACTER_LIMIT}
                </p>
            </div>
            <textarea
                css={textareaStyles}
                value={tempValue}
                onChange={handleReviewChange}
            />
        </div>
        <div css={modalContentFooterStyle}>
            <Button
            variant={"brand"}
            style={{ backgroundColor: '#000' }}
            onClick={() => handleCancel()}
            >
            {t("analysis_draft_cancel")}
            </Button>
            <Button
            variant={"brand"}
            style={{ backgroundColor: theme.colors.primary }}
            onClick={handleSave}
            disabled={tempValue === "" || characterCount >= CHARACTER_LIMIT}
            className="brandPrimaryBtn"
            >              
            {t("analysis_draft_save")}
            </Button>
        </div>
      </div>
    </div>
  );
}
